<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 7.10156C12.55 7.10156 13 7.55156 13 8.10156V12.1016C13 12.6516 12.55 13.1016 12 13.1016C11.45 13.1016 11 12.6516 11 12.1016V8.10156C11 7.55156 11.45 7.10156 12 7.10156ZM11.99 2.10156C6.47 2.10156 2 6.58156 2 12.1016C2 17.6216 6.47 22.1016 11.99 22.1016C17.52 22.1016 22 17.6216 22 12.1016C22 6.58156 17.52 2.10156 11.99 2.10156ZM12 20.1016C7.58 20.1016 4 16.5216 4 12.1016C4 7.68156 7.58 4.10156 12 4.10156C16.42 4.10156 20 7.68156 20 12.1016C20 16.5216 16.42 20.1016 12 20.1016ZM13 17.1016H11V15.1016H13V17.1016Z"
      fill="#EE3B3B"
    />
  </svg>
</template>
